module.exports = __webpack_public_path__ + "img/HOGE.3fdb3278.svg";